// src/services/httpService.js
import axios from 'axios';
import store from '../store/store';
const API_URL = 'https://ashaapi.bluai.ai/api/asha' || 'https://ashaapi.bluai.ai/api/asha';

  
const getAshaAndVillage = () => {              
  try {       
    const state = store.getState();
    const selectedVillageId = state?.village?.selectedVillageId;
    return {
      villageID: selectedVillageId || localStorage.getItem('VillageId'),
    };
  } catch (err) {
    return {
      villageID: localStorage.getItem('VillageId'),
    };
  }
};
  

const { villageID } = getAshaAndVillage();

const http = axios.create({
  baseURL: API_URL,    
  headers: { 
    'Content-Type': 'application/json',
  },
});

// 🔐 Request Interceptor: Add token automatically
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const { villageID } = getAshaAndVillage();

    console.log('Sending token:', token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (villageID) {
      config.headers.villageId = villageID;
    }

    return config;
  },
  (error) => Promise.reject(error) 
);
   


http.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorData = error.response?.data || { message: 'Something went wrong' };
    return Promise.reject(errorData);
  }
);

export default http;
